import { render, staticRenderFns } from "./ProfitabilityChartCard.vue?vue&type=template&id=6cdffb33&scoped=true"
import script from "./ProfitabilityChartCard.vue?vue&type=script&lang=js"
export * from "./ProfitabilityChartCard.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityChartCard.vue?vue&type=style&index=0&id=6cdffb33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdffb33",
  null
  
)

export default component.exports